var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlumeTextLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1224 792",
    style: {
      enableBackground: "new 0 0 1224 792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.5,387.6h50.2c11.5,0,20.3,2.8,26.1,8.5c5.5,5.1,8.5,11.8,8.5,20.3c0,11.5-6.3,19.1-18.2,22.6v0.4 c13.9,3.3,22.6,12.8,22.6,26.8c0,9.8-3.6,17.6-9.8,22.9c-6.4,6-15.6,9.2-27.6,9.2h-51.9L359.5,387.6L359.5,387.6z M406.7,433.3 c10.7,0,17.4-5.2,17.4-14.8c0-9.1-6.3-14.5-16.4-14.5h-27.9v29.2L406.7,433.3L406.7,433.3z M409.5,481.6c6.3,0,11-1.8,14-4.8 c2.8-2.7,4.5-6.6,4.5-11.3c0-11.3-8-16.8-19.1-16.8h-29.1v32.9L409.5,481.6L409.5,481.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.2,387.6h20.6v92.8h53.9v18h-74.5V387.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524.1,461v-73.5h20.6v73.2c0,14.9,8.2,22.5,24,22.5c15,0,23.5-7.9,23.5-22.8v-72.9H613V461 c0,26.2-17.1,39.3-44.4,39.3C541,500.4,524.1,487.4,524.1,461z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M621.4,387.6h27.3l18.2,52.7c4.3,13,9.7,37.2,9.7,37.2h0.4c0,0,5.4-24.1,9.5-37.2l17.9-52.7h27.9v110.9h-19.2 v-57.8c0-12.1,1.3-34.6,1.3-34.6h-0.3c0,0-4.6,20.4-8.2,31.4l-21,60.9h-16.7L647,437.5c-3.6-11-8.2-31.4-8.2-31.4h-0.3 c0,0,1.3,22.5,1.3,34.6v57.8h-18.5L621.4,387.6L621.4,387.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M741.3,387.6h81.1v17.6h-60.5v27.4h53.5v16.5h-53.5v31.3h61.8v18h-82.4L741.3,387.6L741.3,387.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlumeTextLogo);
export default __webpack_public_path__ + "static/media/Blume_text_logo.403c6bd75ac4935a957ca650cf7eb965.svg";
export { ForwardRef as ReactComponent };